export const careers = () => {

	let el = document.querySelector('[data-el="roles"]')

	if (!el) return

	const buttons = el.querySelectorAll('[data-set-category]')
	const items = el.querySelectorAll('[data-category]')

	buttons.forEach(btn => {
		btn.addEventListener('click', () => {
			// remove active from all, add to clicked
			buttons.forEach(b => b.classList.remove('active'))
			btn.classList.add('active')

			const category = btn.getAttribute('data-set-category')

			items.forEach(item => {
				const itemCategory = item.getAttribute('data-category')

				if (category === 'all' || itemCategory === category) {
					item.style.display = ''
				} else {
					item.style.display = 'none'
				}
			})
		})
	})
}

export default () => { }